// Redux logs module
// see https://github.com/erikras/ducks-modular-redux

import { Log } from '../../models';
import { Logs } from '../../services';

const LOADING_LOGS         = 'kronos/logs/LOADING_LOGS';
const LOADING_LOGS_SUCCESS = 'kronos/logs/LOADING_LOGS_SUCCESS';
const LOADING_LOGS_FAILURE = 'kronos/logs/LOADING_LOGS_FAILURE';

const CLEAR_LAST_SCREENING_IMPORT_LOGS          = 'kronos/logs/CLEAR_LAST_SCREENING_IMPORT_LOGS';
const TKTSYNCING_LEGACY_SCREENINGS_SUCCESS      = 'kronos/legacyScreenings/TKTSYNCING_LEGACY_SCREENINGS_SUCCESS';

const CLEAR_LAST_TICKET_IMPORT_LOGS = 'kronos/logs/CLEAR_LAST_TICKET_IMPORT_LOGS';
const IMPORTING_TICKETS_SUCCESS     = 'kronos/tickets/IMPORTING_TICKETS_SUCCESS';
const PREVIEWING_TICKETS            = 'kronos/tickets/PREVIEWING_TICKETS';

const ENGINE_LOGS_SEARCHING         = 'kronos/logs/ENGINE_LOGS_SEARCHING';
const ENGINE_LOGS_SEARCH_SUCCESS  = 'kronos/logs/ENGINE_LOGS_SEARCH_SUCCESS';
const ENGINE_LOGS_SEARCH_FAILURE  = 'kronos/logs/ENGINE_LOGS_SEARCH_FAILURE';
const ENGINE_LOGS_SEARCH_RESET      = 'kronos/logs/ENGINE_LOGS_SEARCH_RESET';

const initialState = {
    isLoading: false,
    hasLoadingError: false,
    loadingErrorMessage: '',
    logSuccessfullyCreated: false,
    logs: [],
    lastScreeningImportLogs: [],
    lastTicketImportLogs: [],
    engine_logs_list: [],
    engine_logs_isLoading: false,
    engine_logs_listFetchScope: 'idle',
    engine_logs_hasError: false,
    engine_logs_errorMessage: '',
    engine_logs_has_searched: false,
    /** Which screen last requested `searchEngineLogs` — isolates 500-row UI from other analysis pages. */
    engine_logs_last_search_source: null,
}

// Reducer
export default function reducer(state = initialState, action) {
    switch(action.type) {
        case LOADING_LOGS:
            return {
                ...state,
                isLoading: true,
                logSuccessfullyDeleted: false,
                hasLoadingError: false
            };
        case CLEAR_LAST_SCREENING_IMPORT_LOGS:
            return {
                ...state,
                lastScreeningImportLogs: []
            };
        case CLEAR_LAST_TICKET_IMPORT_LOGS:
        case PREVIEWING_TICKETS:
            return {
                ...state,
                lastTicketImportLogs: []
            };
        case LOADING_LOGS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: false,
                logs: action.logs
            };
        case TKTSYNCING_LEGACY_SCREENINGS_SUCCESS:
            return {
                ...state,
                lastScreeningImportLogs: action.imported?.logs.map(log => new Log(log))
            };
        case IMPORTING_TICKETS_SUCCESS:
            return {
                ...state,
                lastTicketImportLogs: action.imported?.logs.map(log => new Log(log))
            };
        case LOADING_LOGS_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasLoadingError: true,
                loadingErrorMessage: action.error.message
            };
        case ENGINE_LOGS_SEARCHING:
            return {
                ...state,
                engine_logs_isLoading: true,
                engine_logs_listFetchScope: action.fetchScope ?? 'major',
                engine_logs_hasError: false,
                engine_logs_errorMessage: '',
            };
        case ENGINE_LOGS_SEARCH_SUCCESS:
            return {
                ...state,
                engine_logs_isLoading: false,
                engine_logs_listFetchScope: 'idle',
                engine_logs_list: action.logs,
                engine_logs_has_searched: true,
                engine_logs_hasError: false,
                engine_logs_errorMessage: '',
                engine_logs_last_search_source:
                    action.searchSource !== undefined ? action.searchSource : null,
            };
        case ENGINE_LOGS_SEARCH_FAILURE:
            return {
                ...state,
                engine_logs_isLoading: false,
                engine_logs_listFetchScope: 'idle',
                engine_logs_list: [],
                engine_logs_has_searched: true,
                engine_logs_hasError: true,
                engine_logs_errorMessage: action.error.message,
                engine_logs_last_search_source: null,
            };
        case ENGINE_LOGS_SEARCH_RESET:
            return {
                ...state,
                engine_logs_list: [],
                engine_logs_isLoading: false,
                engine_logs_listFetchScope: 'idle',
                engine_logs_hasError: false,
                engine_logs_errorMessage: '',
                engine_logs_has_searched: false,
                engine_logs_last_search_source: null,
            };
        default:
            return state;
    }
};

// Actions
function loadingLogs() { return { type: LOADING_LOGS } }
function loadingLogsSuccess(logs) { return { type: LOADING_LOGS_SUCCESS, logs } }
function loadingLogsFailure(error) { return { type: LOADING_LOGS_FAILURE, error } }
export function loadLogs(params) {
    return (dispatch) => {
        dispatch(loadingLogs());
        Logs.list(params)
            .then(data => {
                const logs = data.logs;
                dispatch(loadingLogsSuccess(logs));
            })
            .catch(err => {
                console.log("err => ", err);
                dispatch(loadingLogsFailure(err))
            });
    }
}
export function loadScreeningLogs(screeningId) {
    return loadLogs({ screening_ids: screeningId });
};

export function clearLastScreeningImportLogs() {
    return { type: CLEAR_LAST_SCREENING_IMPORT_LOGS }
}

export function clearLastTicketImportLogs() {
    return { type: CLEAR_LAST_TICKET_IMPORT_LOGS }
}

function engineLogsSearching(fetch_scope) {
    return { type: ENGINE_LOGS_SEARCHING, fetchScope: fetch_scope ?? 'major' };
}
function engineLogsSearchSuccess(logs, searchSource) {
    return { type: ENGINE_LOGS_SEARCH_SUCCESS, logs, searchSource };
}
function engineLogsSearchFailure(error) {
    return { type: ENGINE_LOGS_SEARCH_FAILURE, error };
}

/**
 * Search engine logs (Exploitation > Journaux). Isolated from screening `logs` state.
 */
export function searchEngineLogs(params, options = {}) {
    const fetch_scope = options.fetchScope ?? 'major';
    const searchSource = options.searchSource ?? null;
    return (dispatch) => {
        dispatch(engineLogsSearching(fetch_scope));
        return Logs.list(params)
            .then((data) => {
                dispatch(engineLogsSearchSuccess(data.logs, searchSource));
            })
            .catch((err) => {
                dispatch(engineLogsSearchFailure(err));
            });
    };
}

export function resetEngineLogsSearch() {
    return { type: ENGINE_LOGS_SEARCH_RESET };
}
